import { render, staticRenderFns } from "./ExportExtractInfoModal.vue?vue&type=template&id=a2c83e96&scoped=true&"
import script from "./ExportExtractInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ExportExtractInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./ExportExtractInfoModal.vue?vue&type=style&index=0&id=a2c83e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c83e96",
  null
  
)

export default component.exports